export default __webpack_public_path__ + "static/media/refresh.bc937be0.svg";